import { FAQ } from '@/components/about/FAQ';
import { InfoPageBackLink } from '@/components/layout/InfoPageBackLink';

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-surface">
      <div className="ornamental-rule max-w-7xl mx-auto px-4 pt-6 sm:pt-8" />
      <div className="max-w-7xl mx-auto px-4 py-6 sm:py-8">
        <InfoPageBackLink />

        <div className="text-center mb-4">
          <span className="text-gold text-[10px] sm:text-xs font-bold tracking-[0.2em] uppercase mb-3 sm:mb-4 block">
            Help Center
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-cream mb-4 sm:mb-6">
            Frequently Asked Questions
          </h1>
          <p className="text-base sm:text-lg text-warm-gray max-w-2xl mx-auto px-2">
            Everything you need to know about FantasyPRIME.
          </p>
        </div>
        <FAQ />
      </div>
    </div>
  );
}
